export const formatNumber = (
    value?: number,
    maxDecimalPlaces = 2
): string | undefined => {
    if (value === undefined || value === null) return undefined;

    const locale = navigator.language;

    // Rounding very large numbers is not reliable and so use none when number is large.
    const format = Intl.NumberFormat(locale, {
        maximumFractionDigits: value >= 10000 ? 0 : maxDecimalPlaces,
    });

    const formattedNumber = format.format(value);

    const isRounded = parseFloat(value.toFixed(maxDecimalPlaces)) !== value;

    return isRounded ? `~${formattedNumber}` : formattedNumber;
};
